import { useContext, useState } from 'react';

import './AddressFormSend.scss';

import { Input } from '../../../../Components/Input';
import useResponsive from '../../../../hooks/useResponsive';
import {
  AddressContext,
  AddressContextProps,
} from '../../../../Contexts/AddressContext';
import { Dropdown } from '../../../../Components/Dropdown';
import {
  OrderContext,
  OrderContextProps,
} from '../../../../Contexts/OrderContext';
import OptionProvince from '../../../../types/OptionProvince';

export const AddressFormSend = () => {
  const { isDesktopOrLaptop } = useResponsive();
  const { addressSend }: AddressContextProps = useContext<any>(AddressContext);
  const { getCalculatedShippingCost }: OrderContextProps =
    useContext<any>(OrderContext);
  const [postCodeLetter, setPostCodeLetter] = useState(
    addressSend.addressSendForm.province?.postal_code_letter ?? ''
  );

  const onBlurInput = () => {
    if (addressSend.addressSendFormErrors) {
      addressSend.validateAddressSendForm();
    }
  };

  const onChangeAddress = (text: string) => {
    addressSend.setAddressSendForm({
      ...addressSend.addressSendForm,
      address: text,
    });
  };

  const onChangeAddressDetails = (text: string) => {
    addressSend.setAddressSendForm({
      ...addressSend.addressSendForm,
      addressDetails: text,
    });
  };

  const onChangeLocation = (text: string) => {
    addressSend.setAddressSendForm({
      ...addressSend.addressSendForm,
      location: text,
    });
  };

  const onChangeProvince = (selectedOption: OptionProvince) => {
    const postalCodeLetter = selectedOption.postal_code_letter ?? '';
    setPostCodeLetter(postalCodeLetter);

    addressSend.setAddressSendForm({
      ...addressSend.addressSendForm,
      province: selectedOption,
      postalCode: postalCodeLetter,
    });
  };

  const onChangePostalCode = (text: string) => {
    const newText = text.replace(postCodeLetter, '').replace(/[^0-9]/g, '');
    const sanitizedText = newText.slice(0, 5);
    const fullPostalCode = `${postCodeLetter}${sanitizedText}`;

    addressSend.setAddressSendForm({
      ...addressSend.addressSendForm,
      postalCode: fullPostalCode,
    });

    if (fullPostalCode.length === 5) {
      getCalculatedShippingCost({ postalCode: fullPostalCode });
    }
  };

  const onChangeAdditionalNotes = (text: string) => {
    addressSend.setAddressSendForm({
      ...addressSend.addressSendForm,
      additionalNotes: text,
    });
  };

  return isDesktopOrLaptop ? (
    <div className="address-form-desktop">
      <div className="item">
        <Input
          title="Dirección"
          onChange={onChangeAddress}
          onBlur={onBlurInput}
          value={addressSend.addressSendForm.address}
          error={addressSend.addressSendFormErrors?.address}
        />

        <Input
          title="Piso / Depto / Oficina"
          onChange={onChangeAddressDetails}
          onBlur={onBlurInput}
          value={addressSend.addressSendForm.addressDetails}
          error={addressSend.addressSendFormErrors?.addressDetails}
        />
      </div>

      <div className="item">
        <Dropdown
          title="Provincia"
          options={addressSend.provinceOptions}
          value={addressSend.addressSendForm.province?.value}
          onChange={onChangeProvince}
          error={addressSend.addressSendFormErrors?.province}
        />
        <Input
          title="Localidad"
          onChange={onChangeLocation}
          onBlur={onBlurInput}
          value={addressSend.addressSendForm.location}
          error={addressSend.addressSendFormErrors?.location}
        />

        <Input
          title="Código Postal"
          onChange={onChangePostalCode}
          onBlur={onBlurInput}
          value={`${addressSend.addressSendForm.postalCode}`}
          error={addressSend.addressSendFormErrors?.postalCode}
          disabled={!addressSend.addressSendForm.province}
          length={5}
        />
      </div>

      <div className="item">
        <Input
          title="Notas adicionales"
          multiline
          onChange={onChangeAdditionalNotes}
          value={addressSend.addressSendForm.additionalNotes}
        />
      </div>
    </div>
  ) : (
    <div className="address-form-mobile">
      <Input
        title="Dirección"
        onChange={onChangeAddress}
        onBlur={onBlurInput}
        value={addressSend.addressSendForm.address}
        error={addressSend.addressSendFormErrors?.address}
      />

      <Input
        title="Piso / Depto / Oficina"
        onChange={onChangeAddressDetails}
        onBlur={onBlurInput}
        value={addressSend.addressSendForm.addressDetails}
        error={addressSend.addressSendFormErrors?.addressDetails}
      />

      <Input
        title="Localidad"
        onChange={onChangeLocation}
        onBlur={onBlurInput}
        value={addressSend.addressSendForm.location}
        error={addressSend.addressSendFormErrors?.location}
      />

      <Dropdown
        title="Provincia"
        options={addressSend.provinceOptions}
        value={addressSend.addressSendForm.province?.value}
        onChange={onChangeProvince}
        error={addressSend.addressSendFormErrors?.province}
      />

      <Input
        title="Código Postal"
        onChange={onChangePostalCode}
        onBlur={onBlurInput}
        value={`${addressSend.addressSendForm.postalCode}`}
        error={addressSend.addressSendFormErrors?.postalCode}
        disabled={!addressSend.addressSendForm.province}
        length={5}
      />

      <Input
        title="Notas adicionales"
        multiline
        onChange={onChangeAdditionalNotes}
        value={addressSend.addressSendForm.additionalNotes}
      />
    </div>
  );
};
